import { Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralAction } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { LeadSourcesDataService } from '@services/lead-sources/lead-sources.data.service';
import { LeadSourceItem } from '@models/lead-sources.model';

@Component({
	selector: 'delete-lead-source',
	template: require('./delete-lead-source-modal.component.html'),
	styles: [require('./delete-lead-source-modal.component.scss')]
})
export class DeleteLeadSourceModalComponent implements OnDestroy {
	@Input() leadSource: LeadSourceItem;
	@Input() action: GeneralAction;
	@Input() leadSourcesList: Array<LeadSourceItem>;
	@Input() linkedEvents: number;

	btnDisabled: boolean;
	leadSourceToMergeInto: LeadSourceItem = null;
	confirmWord: string;
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		public activeModal: NgbActiveModal,
		private leadSourcesService: LeadSourcesDataService,
		private messageService: MessageService
	) {}

	ngOnInit(): void {
		this.sortLeadSources();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	onSelectChange(value: LeadSourceItem): void {
		this.leadSourceToMergeInto = value;
	}

	deleteLeadSource(): void {
		if (this.confirmWord && this.confirmWord.toUpperCase() === 'DELETE') {
			this.btnDisabled = true;
			this.leadSourcesService
				.sendAction(this.action.url, this.action.method, {
					destLeadSourceId: this.leadSourceToMergeInto
						? this.leadSourceToMergeInto.id
						: null
				})
				.pipe(
					takeUntil(this.unsubscribe),
					finalize((): boolean => (this.btnDisabled = false))
				)
				.subscribe(
					(): void => this.activeModal.close(),
					(err): void => this.handleError(err)
				);
		} else {
			this.messageService.showToaster('e_3', 'leadSources');
		}
	}

	onDismiss(): void {
		if (!this.btnDisabled) {
			this.activeModal.dismiss();
		}
	}

	private sortLeadSources(): void {
		const sortFunction = (a: LeadSourceItem, b: LeadSourceItem): number =>
			a.name.localeCompare(b.name);

		const sortedActive = this.leadSourcesList
			.filter((item: LeadSourceItem): boolean => item.status === 'ACTIVE')
			.sort(sortFunction);
		const sortedArchived = this.leadSourcesList
			.filter((item: LeadSourceItem): boolean => item.status === 'ARCHIVED')
			.sort(sortFunction);

		this.leadSourcesList = [...sortedActive, ...sortedArchived];
	}

	private handleError({ error }): void {
		const { errorMessage, errorTitle } = error;
		this.messageService.showErrorFromBackend(errorTitle, errorMessage);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.ts